import React, { Component } from 'react'
import { Button, Divider, Table } from 'antd'
import PropTypes from 'prop-types'
import { actions as purchaseOrderActions } from '../../redux/modules/jobFunctions/purchaseOrderActions'
import _ from 'lodash'

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'

const propTypes = {
  changeCreateChangeOrderStep: PropTypes.func.isRequired,
  updateSelectedEstimateItems: PropTypes.func.isRequired,
  setSelectedEstimateId: PropTypes.func.isRequired,
  // from actions
  getEstimate: PropTypes.func.isRequired
}

class PurchaseOrderCreationStep0 extends Component {
  selectEstimate = estimateId => {
    const { getEstimate, changeCreateChangeOrderStep, setSelectedEstimateId } = this.props

    setSelectedEstimateId(estimateId)

    // get the estimate
    getEstimate({ estimateId })
    // change the step
    changeCreateChangeOrderStep(1)
  }

  getEstimatesColumns = () => {
    return [
      {
        title: 'ID',
        dataIndex: 'estimate_id',
        key: 'id'
      },
      {
        title: 'Estimate Name',
        dataIndex: 'estimate_name',
        key: 'estimate_name'
      },
      {
        title: 'Estimate Description',
        dataIndex: 'estimate_description',
        key: 'estimate_description'
      },
      {
        title: 'Action',
        key: 'action',
        render: (text, record) => {
          return (
            <span>
              <Button block onClick={() => this.selectEstimate(record.estimate_id)}>
                Select
              </Button>
            </span>
          )
        }
      }
    ]
  }

  getEstimatesData = () => {
    const estimates = _.get(this.props, 'purchaseOrder.estimates')

    const data = []

    if (estimates) {
      estimates.forEach(estimate => {
        const dataTmp = {
          key: estimate.estimate_id,
          id: estimate.estimate_id,
          estimate_name: estimate.estimate_name,
          estimate_description: estimate.estimate_description
        }
        data.push(dataTmp)
      })
    }

    return data
  }

  createBlank = () => {
    const { updateSelectedEstimateItems, changeCreateChangeOrderStep } = this.props
    updateSelectedEstimateItems([])
    changeCreateChangeOrderStep(2)
  }

  render() {
    const { changeCreateChangeOrderStep } = this.props
    const loadingEstimates = _.get(this.props, 'purchaseOrder.loading')
    const estimates = _.get(this.props, 'purchaseOrder.estimates.data')

    return (
      <div className="row mt-4">
        <div className="col-12">
          <Button size="large" icon="file" block onClick={() => changeCreateChangeOrderStep(2)}>
            Create a blank Purchase Order
          </Button>
          <Divider>Or create a Purchase Order from an existing estimate</Divider>
          <Table
            loading={loadingEstimates}
            columns={this.getEstimatesColumns()}
            dataSource={estimates}
            pagination={false}
          />
        </div>
      </div>
    )
  }
}

PurchaseOrderCreationStep0.propTypes = propTypes

const mapStateToProps = ({ purchaseOrder }, ownProps) => ({
  purchaseOrder
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(Object.assign({}, purchaseOrderActions), dispatch)
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PurchaseOrderCreationStep0))



// WEBPACK FOOTER //
// ./src/components/purchaseorders/PurchaseOrderCreationStep0.js